/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>View perpendicular face.</h4>

<p>Switch view perpendicular to selected face.</p>`;

export default function ViewFaceTooltip() {
    return h('div', { innerHTML: body });
}
